import { 
    MembershipProductApi, 
    WebApiMembershipProductDtoCreateMembershipProductDto,
    WebApiMembershipProductDtoUpdateMembershipProductDto,
    ApiMembershipProductIdDeleteRequest,
    ApiMembershipProductIdPutRequest
} from "../Repository/eventbookyapi";
import { GetApiConfiguration } from "./ServiceConfiguration";

export abstract class MembershipProductService {
    // Create a new membership product
    public static CreateMembershipProduct = async (request: WebApiMembershipProductDtoCreateMembershipProductDto) => {
        return new MembershipProductApi(GetApiConfiguration()).apiMembershipProductPost({
            webApiMembershipProductDtoCreateMembershipProductDto: request
        });
    };

    // Get all membership products
    public static GetAllMembershipProducts = async () => {
        return new MembershipProductApi(GetApiConfiguration()).apiMembershipProductGet();
    };

    // Note: Get by ID is not available in the API - you'll need to filter from GetAllMembershipProducts
    // or the API needs to be updated to include a GET by ID endpoint

    // Update an existing membership product
    public static UpdateMembershipProduct = async (membershipProductId: number, request: WebApiMembershipProductDtoUpdateMembershipProductDto) => {
        return new MembershipProductApi(GetApiConfiguration()).apiMembershipProductIdPut({
            id: membershipProductId,
            webApiMembershipProductDtoUpdateMembershipProductDto: request
        });
    };

    // Delete a membership product
    public static DeleteMembershipProduct = async (membershipProductId: number) => {
        return new MembershipProductApi(GetApiConfiguration()).apiMembershipProductIdDelete({
            id: membershipProductId
        });
    };

    // Helper method to get a specific membership product by filtering all products
    public static GetMembershipProductById = async (membershipProductId: number) => {
        const allProducts = await MembershipProductService.GetAllMembershipProducts();
        return allProducts.find(product => product.id === membershipProductId);
    };
};
